
import { Options, Vue } from 'vue-class-component';
import Games from "@/components/Games.vue";
import Logo from "@/base-components/Logo.vue"; // @ is an alias to /src

@Options({
  components: {
    Games,
    Logo
  },
})
export default class GamesView extends Vue {}
